var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAvatarDefault(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B1C4F",
    fillRule: "nonzero",
    d: "M10.2769514 12.8571429C15.8140622 12.8571429 20.3292672 17.2324422 20.5539027 22.7143773L18.5517958 22.7147319C18.3290059 18.3376294 14.7094342 14.8571429 10.2769514 14.8571429 5.84446851 14.8571429 2.22489684 18.3376294 2.00210695 22.7147319L-1.39376358e-14 22.7143773C.224635517 17.2324422 4.73984048 12.8571429 10.2769514 12.8571429zM10.2769514-4.4408921e-15C13.4328642-4.4408921e-15 15.9912371 2.55837286 15.9912371 5.71428571 15.9912371 8.87019857 13.4328642 11.4285714 10.2769514 11.4285714 7.1210385 11.4285714 4.56266565 8.87019857 4.56266565 5.71428571 4.56266565 2.55837286 7.1210385-4.4408921e-15 10.2769514-4.4408921e-15zM10.2769514 2C8.225608 2 6.56266565 3.66294236 6.56266565 5.71428571 6.56266565 7.76562907 8.225608 9.42857143 10.2769514 9.42857143 12.3282947 9.42857143 13.9912371 7.76562907 13.9912371 5.71428571 13.9912371 3.66294236 12.3282947 2 10.2769514 2z",
    transform: "translate(9.723 8.286)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAvatarDefault);
export default __webpack_public_path__ + "static/media/ic-avatar-default.cc6e8928b528aee84248b13a63cf19c8.svg";
export { ForwardRef as ReactComponent };